import React from 'react';
import {twMerge} from 'tailwind-merge';

export const SettingLabel = ({
  text,
  htmlFor,
  className,
}: {
  text: string;
  htmlFor?: string;
  className?: string;
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(
        'w-[7rem]',
        'text-base font-semibold leading-[32px]',
        'group-[.is-panel-config]:text-sm', // account for panel config - font size is smaller in there than slider
        className
      )}>
      {text}
    </label>
  );
};
